'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z' });

var SystemUpdate = function SystemUpdate(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SystemUpdate = (0, _pure2.default)(SystemUpdate);
SystemUpdate.muiName = 'SvgIcon';

exports.default = SystemUpdate;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SystemUpdate.js
// module id = 2919
// module chunks = 0